import { render, staticRenderFns } from "./BasicElementsSection.vue?vue&type=template&id=253d03af"
import script from "./BasicElementsSection.vue?vue&type=script&lang=js"
export * from "./BasicElementsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports